
import { LoginUserModel } from './../../models/login-user-model';
import { CommonFunctionService, UserMerchantData } from './../Common/common-function.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { Merchantinfo } from './../../models/merchantinfo';
import { Injectable } from '@angular/core';
import { BankAccountDetailsViewModel } from 'src/app/models/bank-account-details-view-model';
import { MerchantDetailsViewModel } from 'src/app/models/merchant-details-view-model';
import { VposUserDetailAppView } from 'src/app/models/vpos-user-detail-app-view';
import { AuthService } from '../auth.service';
import { BoardingKYCDatasViewModel } from 'src/app/models/boarding-kycdatas-view-model';
import { VposTransactionCount } from 'src/app/models/vpos-transaction-count';
import { VPOSMerchantBoardingFileViewModel } from 'src/app/models/vposmerchant-boarding-file-view-model';
import { PosUserResponse } from '../../models/pos-user-response';
import { BehaviorSubject, Observable, catchError, map } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';
import { VPOS_AgreementList } from 'src/app/models/esign.model';

const swal = require('sweetalert');
export interface FormData {
  UniqueId?: string;
  selectedValue?: number;
  panNumber?: string;
  gstNumber?: string;
  businessName?: string;
  businessAddress?: string;
  pincode?: string;
  city?: string;
  state?: string;
  gstBusinessName?: string;
  gstBusinessAddress?: string;
  gstPinCode?: string;
  gstCity?: string;
  gstState?: string;
  DbaName?: string;
  landmark?: string;
  AccountTypeId?: Number;
  AccountType?: string;
  BusinessTypeId?: any;
  BusinessType?: string;
  selectedUserIndex?: any;

}
@Injectable()

export class RegisterUserService {
  headers: any;
  token: any;
  private formData: FormData = {};
  header: any;
  static transactionCountCache: Observable<VposTransactionCount> = null;
  static transactionCountForRefundCache: Observable<any> = null;
  static merchantKeyIdValidationCache: Observable<LoginUserModel> = null;
  static totalTranReportsCache: Observable<any> = null;
  static boardingKycDataCache: Observable<VPOSMerchantBoardingFileViewModel> = null;
  static merchantServicesAndFeesCache: Observable<LoginUserModel> = null;
  static resellerDetailsCache: Observable<any> = null;
  private merchantSalesData: any = {};

  constructor(private service: AuthService, private http: HttpClient, private common: CommonFunctionService, private router: Router) {
    let loggedUsername = this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid();
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
  }
  private currentStepIndexSource = new BehaviorSubject<number>(0);
  currentStepIndex$ = this.currentStepIndexSource.asObservable();

  updateCurrentStepIndex(index: number) {
    this.currentStepIndexSource.next(index);
  }
  private merchantSalesNameSource = new BehaviorSubject<string>('');
  private merchantSalesContactSource = new BehaviorSubject<string>('');
  private merchantSalesEmailSource = new BehaviorSubject<string>('');
  setFormData(data: FormData) {
    this.formData = { ...this.formData, ...data };
  }

  getFormData(): FormData {
    return this.formData;
  }
  // Observable streams
  merchantSalesName$ = this.merchantSalesNameSource.asObservable();
  merchantSalesContact$ = this.merchantSalesContactSource.asObservable();
  merchantSalesEmail$ = this.merchantSalesEmailSource.asObservable();

  setMerchantSalesContact(name: string, contact: string, email: string): void {
    this.merchantSalesNameSource.next(name);
    this.merchantSalesContactSource.next(contact);
    this.merchantSalesEmailSource.next(email);
  }

  getLatestMerchantSalesContacts(): { name: string; contact: string; email: string } {
    return {
      name: this.merchantSalesNameSource.value,
      contact: this.merchantSalesContactSource.value,
      email: this.merchantSalesEmailSource.value,
    };
  }
  // userRegistration(data) {
  //   return this.service.userSignup(data);
  // }
  userRegistration(data) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post<any>(environment.userSignupUrl, data, { headers: this.headers });
  }

  isEmailIdExist(data) {
    return this.http.get<LoginUserModel>(environment.checkUserEmailAddressUrl + '?email=' + data)
      .pipe(map(response => response), catchError(this.common.handleError));
  }
  EmailIdExist(data) {
    this.GetUserAuthdetails();
    return this.http.get<PosUserResponse>(environment.checkAdminEmailIdUrl + '?email=' + data, { headers: this.headers });
  }

  Resellerinfoes(data) {

    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<Merchantinfo>(environment.resellerinfoesurl + '?merchantKeyId=' + data + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }
  checkDistributorId(data) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.get<Merchantinfo>(environment.checkDistributorUrl + '?distributorId=' + data, { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }


  checkPartnerId(data) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.get<Merchantinfo>(environment.checkPartnerIdUrl + '?partnerId=' + data, { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }
  getMerchantLogoInfo(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VPOSMerchantBoardingFileViewModel>(environment.getMerchantLogoUrl + "?MerchantKeyId=" + data + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers }).pipe(map(response => response), catchError(this.common.handleError));
  }

  getResellerDetails(data) {
    if (!RegisterUserService.resellerDetailsCache) {
      this.GetHeaderdetails();
      const merchantdata: UserMerchantData = this.common.getUserMerchantData();
      RegisterUserService.resellerDetailsCache = this.http.get<any>(environment.GetResellerDetailsUrl + '?merchantKeyId=' + data + "&LoginUserId=" + merchantdata.UserId
        , { headers: this.headers })
        .pipe(
          shareReplay(1),
          catchError(this.common.handleError)
        );
    }
    return RegisterUserService.resellerDetailsCache;
  }

  getboardingdocuments(data, MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    var LogInResellerId = this.common.getUserMerchantData().ResellerId;
    return this.http.get<any>(environment.getBoardingdataUrl + "?ResellerId=" + LogInResellerId + "&MerchantKeyId=" + MerchantKeyId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers }).pipe(map(response => response), catchError(this.common.handleError));
  }
  isValidMerchantKeyId(data, resellerId) {
    if (!RegisterUserService.merchantKeyIdValidationCache) {
      this.GetHeaderdetails();
      let merchantdata: UserMerchantData = this.common.getUserMerchantData();
      RegisterUserService.merchantKeyIdValidationCache = this.http.get<LoginUserModel>(environment.isValidMerchantKeyIdUrl + '?merchantKeyId=' + data + "&ResellerId=" + resellerId + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
        .pipe(
          shareReplay(1),
          catchError(this.common.handleError)
        );
    }
    return RegisterUserService.merchantKeyIdValidationCache;
  }
  gettermsconditioncontent(data) {
    return this.http.get<any>(environment.gettermsconditioncontent + '?merchantKeyId=' + data)
      .pipe(map(response => response), catchError(this.common.handleError));
  }
  GstNonEnrollmentcontent(data, resellerId) {
    this.GetHeaderdetails();
    let merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GstNonEnrollment + '?merchantKeyId=' + data + "&ResellerId=" + resellerId + "&LoginUserId=" + merchantdata.UserId)
      .pipe(map(response => response), catchError(this.common.handleError));
  }
  GstMerchantagreementcontent(data, resellerId) {
    this.GetHeaderdetails();
    let merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getMerchantAgreementUsingName + '?MerchantKeyId=' + data.MerchantKeyId + "&LogInResellerId=" + resellerId + "&docName=" + data.docName, { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }


  UserPreferenceSettings(MerchantKeyId, UserId, Username) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get(environment.InserUserPreferenceSettingsUrl + "?MerchantKeyId=" + MerchantKeyId + "&UserId=" + UserId + "&UserName=" + Username + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }

  KycData(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));

    return this.http.post<any>(environment.AddKYCUrl, data, { headers: this.headers });
  }

  GetUserPreferenceSettings(MerchantKeyId, UserId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.get(environment.GetUserPreferenceSettingsUrl + "?MerchantKeyId=" + MerchantKeyId + "&UserId=" + UserId + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }

  getMerchantDetails(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));

    return this.http.get<MerchantDetailsViewModel>(environment.getMerchantDetailsUrl + '?merchantKeyId=' + data + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }
  getMerchantBusinessDetails(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<MerchantDetailsViewModel>(environment.GetMerchantBusinessDetailsUrl + '?merchantkeyId=' + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }
  getBusinessAddressDetails(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VposUserDetailAppView>(environment.getBusinessAddressDetailsUrl + '?merchantKeyId=' + data + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }


  getMerchantBoardingHistores(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getMerchantBoardingHistoryUrl + '?merchantKeyId=' + data + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }

  getBoardingKYCDatas(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<BoardingKYCDatasViewModel>(environment.getBoardingKYCDatasUrl + '?merchantKeyId=' + data + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }

  getBankAccountDetails(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<BankAccountDetailsViewModel>(environment.getBankAccountDetailsUrl + '?merchantKeyId=' + data + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }


  Transactioncount(merchantKeyId, Fromdate, todate) {
    if (!RegisterUserService.transactionCountCache) {
      this.GetHeaderdetails();
      const merchantdata: UserMerchantData = this.common.getUserMerchantData();
      RegisterUserService.transactionCountCache = this.http.get<VposTransactionCount>(environment.TransactionCount + "?MerchantKeyId=" + merchantKeyId + "&Fromdate=" + Fromdate + "&Todate=" + todate + "&LoginUserId=" + merchantdata.UserId + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
        .pipe(
          shareReplay(1),
          catchError(this.common.handleError)
        );
    }
    return RegisterUserService.transactionCountCache;
  }

  getBoardingKycDatas(merchantkeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VPOSMerchantBoardingFileViewModel>(environment.getMerchantKycDataUrl + "?merchantkeyId=" + merchantkeyId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers }).pipe(map(response => response), catchError(this.common.handleError));
  }
  isMobileExist(data) {
    this.GetHeaderdetails();
    return this.http.get<PosUserResponse>(environment.checkAdminMobileUrl + '?Mobile=' + data);
  }

  createNewOrder(data, email) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    // return this.http.post<OrderRequestModel>(environment.createOrderUrl+"?Email="+email, data);

    return this.http.post<any>(environment.createOrderUrl, data, { headers: this.headers });

  }
  GetuserRoleBasedPermissions(userId, appName) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get(environment.getUserRoleBasedPermissions + "?UserId=" + userId + "&AppName=" + appName + "&LoginUserId=" + merchantdata.UserId + "&MerchantKeyId=" + merchantdata.MerchantKeyId, { headers: this.headers })
  }

  getMerchantServicesAndFees(data, resellerid) {
    if (!RegisterUserService.merchantServicesAndFeesCache) {
      this.GetHeaderdetails();
      const merchantdata: UserMerchantData = this.common.getUserMerchantData();
      RegisterUserService.merchantServicesAndFeesCache = this.http.get<LoginUserModel>(environment.getMerchantFeeServicesListSetupUrl + '?merchantkeyId=' + data + "&resellerId=" + resellerid + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
        .pipe(
          shareReplay(1),
          catchError(this.common.handleError)
        );
    }
    return RegisterUserService.merchantServicesAndFeesCache;
  }

  GetMerchantServicesAndFeesEsign(data, resellerid) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<LoginUserModel>(environment.GetMerchantServicesAndFeesEsign + '?merchantkeyId=' + data + "&resellerId=" + resellerid, { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }


  Getproductdata(data) {
    this.GetHeaderdetails();
    return this.http.get<any>(environment.Getproductcodedatavalidation + '?MerchantkeyId=' + data.MerchantKeyId + "&Amount=" + data.OrderAmount + "&Source=" + data.Source)
      .pipe(map(response => response), catchError(this.common.handleError));
  }
  GetReserveFund(MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetReserveFund + '?MerchantKeyId=' + MerchantKeyId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });
  }

  getTotalTranReportsByPaymentMethodUrl(merchantKeyId, Fromdate1, todate1) {
    if (!RegisterUserService.totalTranReportsCache) {
      this.GetHeaderdetails();
      const merchantdata: UserMerchantData = this.common.getUserMerchantData();
      RegisterUserService.totalTranReportsCache = this.http.get<any>(environment.getTotalTranReportsByPaymentMethodUrl + "?merchantKeyId=" + merchantKeyId + "&datefrom=" + Fromdate1 + "&dateTo=" + todate1 + "&LoginUserId=" + merchantdata.UserId
        , { headers: this.headers })
        .pipe(
          shareReplay(1)
        );
    }
    return RegisterUserService.totalTranReportsCache;
  }

  getDateRangeReportsUrl(merchantKeyId, Fromdate1, todate1, searchType) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getDateRangeReportsUrl + "?merchantKeyId=" + merchantKeyId + "&datefrom=" + Fromdate1 + "&dateTo=" + todate1 + "&searchType=" + searchType + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });
  }
  getTranReportsByDateRangeUrl(merchantKeyId, Fromdate1, todate1, searchType) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getTranReportsByDateRangeUrl + "?merchantKeyId=" + merchantKeyId + "&datefrom=" + Fromdate1 + "&dateTo=" + todate1 + "&searchType=" + searchType + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
  }


  getTotalTransactionReportsUrl(merchantKeyId, Fromdate1, todate1) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getTotalTransactionReportsUrl + "?merchantKeyId=" + merchantKeyId + "&datefrom=" + Fromdate1 + "&dateTo=" + todate1 + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })

  }


  GetOnboardMerchantDetails(data) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));

    return this.http.get<any>(environment.GetOnboardMerchantDetails + '?merchantKeyId=' + data + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }


  GetHeaderdetails() {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    let loggedUsername = this.common.getUserName()
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));


  }

  //Get MID From MerchantKeyId
  GetMID(MerchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<string>(environment.getMIDWithMerchantIdUrl + "?MerchantKeyId=" + MerchantKeyId + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers }).pipe(map(response => response), catchError(this.common.handleError));
  }

  Transactioncountforrefund(merchantKeyId, Fromdate, todate) {
    if (!RegisterUserService.transactionCountForRefundCache) {
      this.GetHeaderdetails();
      RegisterUserService.transactionCountForRefundCache = this.http.get<any>(environment.Transactioncountforrefund + "?MerchantKeyId=" + merchantKeyId + "&Fromdate=" + Fromdate + "&Todate=" + todate, { headers: this.headers })
        .pipe(
          shareReplay(1)
        );
    }
    return RegisterUserService.transactionCountForRefundCache;
  }

  //E-sign Verification 
  CheckAadhaarBasedESignUrl(data) {

    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post<any>(environment.CheckAadhaarBasedESignUrl + "?MerchantKeyId=" + merchantdata.MerchantKeyId + "&LogInResellerId=" + merchantdata.ResellerId, data, { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }

  IdfyCheckAadhaarBasedESignUrl(data) {

    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post<any>(environment.IdfyCheckAadhaarBasedESignUrl + "?MerchantKeyId=" + merchantdata.MerchantKeyId + "&LogInResellerId=" + merchantdata.ResellerId, data, { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }

  SignzyCheckAadhaarBasedESignUrl(data) {

    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post<any>(environment.SignzyCheckAadhaarBasedESignUrl + "?MerchantKeyId=" + merchantdata.MerchantKeyId + "&LogInResellerId=" + merchantdata.ResellerId, data, { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }


  GetUserAuthdetails() {
    this.token = "" + ":" + environment.GetAuthenticationToken + ":" + 'IT';
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
  }
  getMerchantFeeServicesListUrl(merchantKeyId, resellerno) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getMerchantFeeServicesListUrl + '?merchantkeyId=' + merchantKeyId + "&resellerId=" + resellerno + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }

  checkDuplicateMerchant(data) {

    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post<any>(environment.getVendorDetailsUrl, data, { headers: this.headers });
    //     .map(response => response)
    //     .catch(this.common.handleError);
  }

  BoardingKycDatas(merchantkeyId) {
    if (!RegisterUserService.boardingKycDataCache) {
      this.GetHeaderdetails();
      const merchantdata: UserMerchantData = this.common.getUserMerchantData();
      RegisterUserService.boardingKycDataCache = this.http.get<VPOSMerchantBoardingFileViewModel>(environment.getKycDataUrl + "?merchantkeyId=" + merchantkeyId + "&LoginUserId=" + merchantdata.UserId
        , { headers: this.headers })
        .pipe(
          shareReplay(1)
        );
    }
    return RegisterUserService.boardingKycDataCache;
  }

  GetMerchantAgreementDetails(data) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post<any>(environment.GetMerchantAgreementDetails, data, { headers: this.headers });

  }
  GetAgreementDownloadFile(data) {

    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post<any>(environment.GetAgreementDownloadFile, data, { headers: this.headers });

  }
  ESignRequestWithDigio(MerchantKeyId, fileBlobUrl, TemplateId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    var LogInResellerId = this.common.getUserMerchantData().ResellerId;
    return this.http.get<any>(environment.ESignRequestWithDigio + '?MerchantKeyId=' + MerchantKeyId + "&LogInResellerId=" + LogInResellerId + "&procesor=4&url=" + fileBlobUrl + "&TemplateId=" + TemplateId, { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }

  ESignRequestStatusWithDigio(MerchantKeyId, client_id, TemplateId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    var LogInResellerId = this.common.getUserMerchantData().ResellerId;
    return this.http.get<any>(environment.ESignStatusRequestWithDigio + '?MerchantKeyId=' + MerchantKeyId + "&LogInResellerId=" + LogInResellerId + "&procesor=4&clientId=" + client_id + "&TemplateId=" + TemplateId, { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }

  GetEsignType(data) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post<any>(environment.GetEsignType, data, { headers: this.headers });

  }
  GetMerchantAgreementDigioStatus(AgreementId, MerchantKeyId) {
    this.GetHeaderdetails();
    var LoginUserId = this.common.getUserMerchantData().UserId;
    var LogInResellerId = this.common.getUserMerchantData().ResellerId;
    return this.http.get<any>(environment.GetMerchantAgreementDigioStatusUrl + "?AgreementId=" + AgreementId + "&MerchantKeyId=" + MerchantKeyId + "&LogInResellerId=" + LogInResellerId + "&LoginUserId=" + LoginUserId
      , { headers: this.headers });
  }

  GetDigioandPaygdetails(AgreementId, MerchantKeyId) {
    this.GetHeaderdetails();
    var LoginUserId = this.common.getUserMerchantData().UserId;
    var LogInResellerId = this.common.getUserMerchantData().ResellerId;

    const requestBody = {
      AgreementId: AgreementId,
      MerchantKeyId: MerchantKeyId,
      LogInResellerId: LogInResellerId,
      LoginUserId: LoginUserId
    };

    return this.http.post<any>(
      environment.GetDigioandPaygdetails,
      requestBody,
      { headers: this.headers }
    );
  }


  GetSettlementUserDetails() {

    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    //  let  postJosn= {
    //    "MerchantKeyId": merchantdata.MerchantKeyId,
    //    "LoginUserId": merchantdata.UserId
    //   }

    return this.http.get<any>(environment.getSettlementDetails + "?merchantKeyId=" + merchantdata.MerchantKeyId + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers });
  }

  GetMerchantOnboardStatus() {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;// + ":" + this.common.getUserMerchantData().ContactNo;
    this.headers = new HttpHeaders().set('Authorization', 'basic ' + btoa(this.token));

    const options = { headers: this.headers };
    const requestBody = { MerchantkeyId: merchantdata.MerchantKeyId };

    return this.http.post<any>(environment.GetMerchantOnboardStatus, requestBody, options).pipe(
      catchError(error => {

        if (error.status === 400) {
          // Handle HTTP 400 error
          swal("Session Expired ", "Your Session has expired. You will be redirected to the login page.", "warning").then(() => {
            localStorage.removeItem('MerchantLogo');
            localStorage.removeItem('logodetails');
            localStorage.removeItem('SettingDetails');
            localStorage.removeItem('uniqueId');
            localStorage.removeItem("MerchantKeyId");
            localStorage.removeItem("VirtualPOSToken");
            this.router.navigate(['/logins'])
          });
        } else if (error.status === 401) {
          // Handle session timeout or unauthorized access
          swal("Session Expired ", "Your Session has expired. You will be redirected to the login page.", "warning").then(() => {
            localStorage.removeItem('MerchantLogo');
            localStorage.removeItem('logodetails');
            localStorage.removeItem('SettingDetails');
            localStorage.removeItem('uniqueId');
            localStorage.removeItem("MerchantKeyId");
            localStorage.removeItem("VirtualPOSToken");
            this.router.navigate(['/logins'])
          });
          // Redirect to login or perform necessary actions for session timeout
        } else {
          // Handle other errors
          swal("Session Expired ", "Your Session has expired. You will be redirected to the login page.", "warning").then(
            () => {
              localStorage.removeItem('MerchantLogo');
              localStorage.removeItem('logodetails');
              localStorage.removeItem('SettingDetails');
              localStorage.removeItem('uniqueId');
              localStorage.removeItem("MerchantKeyId");
              localStorage.removeItem("VirtualPOSToken");
              this.router.navigate(['/logins'])
            });
        }
        // Rethrow the error to propagate it down the observable chain
        return throwError(() => error);
      })
    );
  }

  transactionDetailscount(fromDate, toDate) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.transactionDetailscount + "?MerchantKeyId=" + merchantdata.MerchantKeyId + "&LoginUserId=" + merchantdata.UserId + "&Fromdate=" + fromDate + "&Todate=" + toDate
      , { headers: this.headers });

  }
  getTransactionGraph(fromDate, toDate, QueryFlag) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getTransactionGraph + "?merchantKeyId=" + merchantdata.MerchantKeyId + "&LoginUserId=" + merchantdata.UserId + "&datefrom=" + fromDate + "&dateTo=" + toDate + "&QueryFlag=" + QueryFlag
      , { headers: this.headers });
  }
  getQrcode(MerchantKeyId: number) {
    this.GetHeaderdetails();

    // Create an object to represent the data you want to send in the request body
    const requestBody = {
      MerchantKeyId: MerchantKeyId,
      LoginUserId: this.common.getUserMerchantData().UserId,

      // Add other properties if needed
    };

    return this.http.post<any>(
      environment.getMerchantQRCode,
      requestBody,
      { headers: this.headers }
    );
  }
  getTotalTranReportsByPaymentMethod_V1(fromDate, toDate, QueryFlag) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetTotalTranReportsByPaymentMethod_V1 + "?merchantKeyId=" + merchantdata.MerchantKeyId + "&datefrom=" + fromDate + "&dateTo=" + toDate + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });
  }
  getDashBoardQuickPayLink() {

    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    // Create an object to represent the data you want to send in the request body
    const requestBody = {
      "MerchantKeyId": merchantdata.MerchantKeyId,
      "LoginUserId": merchantdata.UserId
      // Add other properties if needed
    };

    return this.http.post<any>(
      environment.GetDashBoardQuickPayLink,
      requestBody,
      { headers: this.headers }
    );
  }
  getLatestMerchantSalesContact() {

    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    // Create an object to represent the data you want to send in the request body
    const requestBody = {
      "MerchantKeyId": merchantdata.MerchantKeyId,
      "LoginUserId": this.common.getUserMerchantData().UserId,



      // Add other properties if needed
    };

    return this.http.post<any>(
      environment.GetLatestMerchantSalesContact,
      requestBody,
      { headers: this.headers }
    );
  }
  getEsignProcessStatus() {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetEsignProcessStatus + "?merchantKeyId=" + merchantdata.MerchantKeyId + "&resellerId=" + merchantdata.ResellerId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });
  }

  ESignUploadDocument(data) {
    this.GetHeaderdetails();
    return this.http.post<any>(environment.ESignUploadDocument, data, { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }

  getMerchantAgreementList(data) {

    this.GetHeaderdetails();
    return this.http.post<VPOS_AgreementList>(environment.getMerchantAgreementList, data, { headers: this.headers })
      .pipe(map(response => response), catchError(this.common.handleError));
  }

}
